import React from 'react';

import {ListItemButton, ListItemIcon, ListItemText, SvgIcon, useMediaQuery, useTheme} from '@mui/material';
import {Person as PersonIcon} from '@mui/icons-material';
import {Outlet, useNavigate} from 'react-router-dom';

import {DroneIcon} from '@wheeebo/polaris-svg';
import {PageFrame, usePageMenuDrawer} from '@wheeebo/polaris-ui';

import {config} from '@components/Constants';

function AdminPageFrame(): JSX.Element {
  const navigate = useNavigate();
  const theme = useTheme();
  const {open, close} = usePageMenuDrawer();
  const isBigScreen = useMediaQuery(theme.breakpoints.up('sm'));
  const redirect = (path: string) => {
    navigate(path);
    if (!isBigScreen) {
      close?.();
    }
  };
  if (!open || !close) {
    return <></>;
  }
  return (
    <PageFrame
      chipColor="error"
      chipLabel="Admin"
      memberWebsiteURL={config.MEMBER_WEBSITE_URL}
      atcWebsiteURL={config.ATC_WEBSITE_URL}
      menu={
        <>
          <ListItemButton onClick={() => redirect('/vehicles')}>
            <ListItemIcon>
              <SvgIcon>
                <DroneIcon />
              </SvgIcon>
            </ListItemIcon>
            <ListItemText primary="Vehicles" />
          </ListItemButton>
          <ListItemButton onClick={() => redirect('/members')}>
            <ListItemIcon>
              <PersonIcon />
            </ListItemIcon>
            <ListItemText primary="Members" />
          </ListItemButton>
        </>
      }>
      <Outlet />
    </PageFrame>
  );
}

export default React.memo(AdminPageFrame);
